import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DataTable from "../../components/Table/DataTable";

import UneditableInput from "../../components/UneditableInput";
import AdditionalInformation from "../../components/AdditionalInformation";

import { getRecipientsDataBySearch, updateRecipientPercentTax} from "../../services/recipients";
import { getChannels } from "../../services/channel";

import { showAlert } from "../../store/ducks/alert";

import { CircularProgress } from "@material-ui/core";
import { Update } from '@material-ui/icons';

const RecipientsInformation = (props) => {
  const dispatch = useDispatch();
  const [recipient, setRecipient] = useState({});
  const [recipientInformations, setRecipientInformations] = useState([]);
  const [recipientChannel, setRecipientChannel] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getRecipientInformation();
  }, []);

  const getRecipientInformation = async () => {

    const recipientId = props.match.params.id;
   
    try {
      setIsLoading(true);

      const { data } = await getRecipientsDataBySearch("id",recipientId);
      const { data: channelData } = await getChannels(0, {searchItem :"id", search: data.rows[0].channelId});
      setRecipient(data.rows[0]);
      setRecipientChannel(channelData.rows);  
      setRecipientInformations([{
        id: data.rows[0].id,
        paymentOriginId: data.rows[0].paymentOriginId,
        paymentOriginToken: data.rows[0].paymentOriginToken,
        channelId: data.rows[0].channelId,
      }]);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert("error", "Ops! We could not load. 😔"));
      console.log(error);
    }
  };

  const customActions = [
    {
      icon: <Update titleAccess="Update Tax Iugu" />,
      action: item => {
        handleRecipientUpdateTax(item);
      },
    },
  ];

  const handleRecipientUpdateTax = async (rowItem) => {
    try {
      if (rowItem && rowItem.paymentOriginId == 3) {
        await updateRecipientPercentTax(rowItem.id);
        dispatch(showAlert('success', 'Success, approved! 🔥'));
      }dispatch(showAlert('fail', 'Fail, not iugu! 😔'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something wrong happened. 😔'));
    }
  };

  const uneditable = Object.keys(recipient);
  const headers = ['id', 'paymentOriginId', 'paymentOriginToken', 'channelId'];

  if (isLoading)
    return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>Recipients Information</h1>
      </div>
      <section className="update-section">
        <h3>View Properties</h3>
        <form className="update-form">
          <div className="form-fields">
            <UneditableInput data={recipient} labels={uneditable} />
          </div>
        </form>
      </section>
      <section class="additional-section">
        <h3> Recipient </h3>
        <DataTable
          head={headers}
          body={recipientInformations}
          bodyColumn={headers}
          noPagination={true}
          customActions={customActions}
        />
      </section>
      {recipientChannel[0] && (
        <section className="additional-section">
          <h3>Channel</h3>
          <AdditionalInformation
            data={recipientChannel}
            dataKey="name"
            useUid={true}
            path="channels"
          />
        </section>
      )}
    </>
  );
};

export default RecipientsInformation;
